import React from "react";
import { Link } from "gatsby";

import BlogNav from "../BlogNav";
import HomeBlogNavSearch from "../search/Search";
import arrowLeft from "../../../../images/arrow-left.svg";

function PostBlogNav() {
  return (
    <BlogNav>
      <Link to="/" className="blogNav__backContainer">
        <img src={arrowLeft} className="blogNav__back" alt="arrow-left" />

        <span className="blogNav__link blogNav__link--secondary">
          SEE ALL ARTICLES
        </span>
      </Link>
      <HomeBlogNavSearch />
    </BlogNav>
  );
}

export default PostBlogNav;
